/*
 * @Author: Teemo Ding
 * @Date: 2022-03-07 14:46:32
 * @LastEditTime: 2022-06-07 13:43:09
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCommunication/Template/SMSLocalisedRouting/index.tsx
 */
import { Button } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import SelectObjectAsValue from '@/src/components/SelectObjectAsValue';
import { Icon } from '@/src/tools/icon';
import { Form } from 'antd';
import { get } from 'lodash';
import React, { Fragment } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { AreaCodeInfo } from 'src/pages/CustomerDatabaseConfig/Components/CustomerInfoModal';
import { useTemplates } from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCommunication/Template/tools';
import { i18nGet } from 'src/tools/tools';
import TemplateTable from '../../Components/TemplateTable';
import css from '../../css.module.less';

const SmsLocalisedRouting = ({
  areaCodesOptions,
  templates: t,
  form,
  onSendTest,
  channelType,
  category,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const templates = useTemplates({ category, templates: t, channelType });

  const templatesOptions = templates.map((item) => ({
    ...item,
    label: (
      <div className={css.templates}>
        <h3> {item.name}</h3>
        <span> {item.communicationGatewayName}</span> |{' '}
        <span> {item.communicationGatewayRemarks}</span>
      </div>
    ),
  }));

  const calculateCodesOption = (index) => {
    const selectedAreaCodes = form
      .getFieldValue('routingList')
      .filter((_, oIndex) => oIndex !== index)
      .flatMap((item) => (item || {}).areaCode);
    const languagesOption = areaCodesOptions.filter(
      (o) => !selectedAreaCodes.includes(o.areaCode),
    );
    return languagesOption || [];
  };

  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      title={getI18n('salesChannelCommunication.index.sMSLocalisedRouting')}>
      <Form.Item shouldUpdate>
        {({ getFieldValue }) => {
          const v = getFieldValue('routingList') || [];
          const hasError =
            v.length && v.every((o) => !get(o, 'defaultLanguage'));
          return (
            <Form.List
              name='routingList'
              rules={[
                {
                  validator: async (_, values) => {
                    if (
                      values.length &&
                      values.every((o) => !get(o, 'defaultLanguage'))
                    ) {
                      return Promise.reject(
                        new Error(
                          getI18n(
                            'salesChannelCommunication.index.atLeast1DefaultLanguage',
                          ),
                        ),
                      );
                    } else {
                      return Promise.resolve();
                    }
                  },
                },
              ]}>
              {(fields, { add, move, remove }, { errors }) => (
                <Fragment>
                  {fields?.length
                    ? (fields || []).map((item, index) => (
                        <Fragment>
                          <div className={css.routingListTitle}>
                            <Form.Item
                              className={css.routingAreaCode}
                              name={[fields[index].name, 'areaCodeInfo']}
                              labelCol={{ span: 24 }}
                              label={getI18n(
                                'salesChannelCommunication.index.ifrecipientareacodeis',
                              )}>
                              <AreaCodeInfo
                                options={calculateCodesOption(index) || []}
                              />
                              {/* <Select
                          filterOption={(input: any, option: any) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          showSearch
                          allowClear
                          size='large'
                          containerClassName={css.select}>
                          {(calculateCodesOption(index) || []).map((i) => {
                            const { label, value, uuid } = i;
                            return (
                              <Option value={value} key={uuid}>
                                {label}
                              </Option>
                            );
                          })}
                        </Select> */}
                            </Form.Item>
                            <Form.Item
                              className={css.routingTemplateUuid}
                              labelCol={{ span: 24 }}
                              name={[fields[index].name, 'templateUuid']}
                              label={getI18n(
                                'salesChannelCommunication.index.useTemplate',
                              )}>
                              <SelectObjectAsValue
                                className={css.select}
                                showSearch
                                objectAsValue
                                size='large'
                                getPopupContainer={(trigger) => trigger}
                                valueKey='uuid'
                                options={templatesOptions || []}
                                filterOption={(input, option) => {
                                  const indexOption = templates.filter(
                                    (o) => o.uuid === option.value,
                                  );
                                  return (
                                    get(indexOption, [0, 'name'])
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                                  );
                                }}
                              />
                            </Form.Item>
                            {fields.length > 1 && (
                              <Icon
                                onClick={() => remove(index)}
                                type='icondelete'
                                className={css.icon}
                              />
                            )}
                          </div>
                          <TemplateTable
                            id='templateInformation'
                            channelType={channelType}
                            onSendTest={(languageTag) =>
                              onSendTest(
                                languageTag,
                                (
                                  getFieldValue([
                                    'routingList',
                                    fields[index].name,
                                    'templateUuid',
                                  ]) || {}
                                ).uuid || '',
                              )
                            }
                            dataSource={
                              (
                                getFieldValue([
                                  'routingList',
                                  fields[index].name,
                                  'templateUuid',
                                ]) || {}
                              ).availableLanguages || []
                            }
                            defaultLanguageName={[
                              fields[index].name,
                              'defaultLanguage',
                            ]}
                          />
                        </Fragment>
                      ))
                    : null}
                  {hasError ? (
                    <div className={css.errorTip}>
                      {getI18n(
                        'salesChannelCommunication.index.atLeast1DefaultLanguage',
                      )}
                    </div>
                  ) : null}
                  {errors.length ? <Form.ErrorList errors={errors} /> : null}
                  <Button type='primary' onClick={() => add()}>
                    {getI18n(
                      'salesChannelCommunication.index.addLocalisedRouting',
                    )}
                  </Button>
                </Fragment>
              )}
            </Form.List>
          );
        }}
      </Form.Item>
    </SectionWrapper>
  );
};

export default SmsLocalisedRouting;
